export default __webpack_public_path__ + "static/media/me3_carousel_RightArrow.f6d4d724.svg";